import correos from './correos'
import reportes from './reportes'

const routes = [
  {
    path: '/configuracion/roles',
    name: 'roles',
    component: () => import('@/views/Configuracion/Roles')
  }, {
    path: '/configuracion/estados',
    name: 'estados',
    component: () => import('@/views/Configuracion/Estados')
  }, {
    path: '/configuracion/conceptos',
    name: 'conceptos',
    component: () => import('@/views/Configuracion/Conceptos')
  }, {
    path: '/configuracion/tipocasos',
    name: 'tipocasos',
    component: () => import('@/views/Configuracion/Tipos/Index')
  }, {
    path: '/configuracion/prioridades',
    name: 'prioridades',
    component: () => import('@/views/Configuracion/Prioridad')
  }, {
    path: '/configuracion/categorias',
    name: 'categorias',
    component: () => import('@/views/Configuracion/Categorias/Index')
  }, {
    path: '/configuracion/sla',
    name: 'sla',
    component: () => import('@/views/Configuracion/Slo')
  }, {
    path: '/configuracion/productos',
    name: 'productos',
    component: () => import('@/views/Configuracion/Productos')
  }, {
    path: '/configuracion/permisos/rol/:idRol',
    name: 'permisos',
    component: () => import('@/views/Configuracion/Permisos')
  }, {
    path: '/configuracion/navegacion',
    name: 'navegacion',
    component: () => import('@/views/Configuracion/Navegacion')
  }, {
    path: '/configuracion/sistemasexternos',
    name: 'sistemasexternos',
    component: () => import('@/views/Configuracion/SistemasExternos')
  }, {
    path: '/configuracion/camposper',
    name: 'camposper',
    component: () => import('@/views/Configuracion/CamposPersonalizados')
  }, {
    path: '/configuracion/parametros',
    name: 'parametros',
    component: () => import('@/views/Configuracion/Parametros')
  }, {
    path: '/configuracion/diasferiados',
    name: 'diasferiados',
    component: () => import('@/views/Configuracion/DiasFeriados')
  }, {
    path: '/configuracion/parametroswitch',
    name: 'parametroswitch',
    component: () => import('@/views/Configuracion/ParametroSwitch')
  }, {
    path: '/configuracion/historicoconfiguracion',
    name: 'historicoconfiguracion',
    component: () => import('@/views/Configuracion/HistoricoConfiguracion')
  }, {
    path: '/configuracion/respuestaspredefinidas',
    name: 'respuestaspredefinidas',
    component: () => import('@/views/Configuracion/RespuestasPredefinidas')
  }, {
    path: '/configuracion/administrarlistacorreos',
    name: 'adminlistacorreos',
    component: () => import('@/views/Configuracion/ListaCorreos')
  },
  ...correos,
  ...reportes
]

export default routes
